import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import * as Services from 'services/agentDashboard'
import actions from './actions'

export function* FETCH_SALES_AGENT_BY_ID({ payload }) {
  const { agentId } = payload

  yield put({ type: actions.SET_STATE, payload: { salesAgentLoading: true } })

  try {
    const response = yield call(Services.getSalesAgentById, agentId)

    if (!response.error) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          salesAgentLoading: false,
          selectedAgent: response.data || null,
        },
      })
    } else {
      yield put({ type: actions.SET_STATE, payload: { salesAgentLoading: false } })
      showError(response.message)
    }
  } catch (err) {
    yield put({ type: actions.SET_STATE, payload: { salesAgentLoading: false } })
    showError(err.message)
  }
}

export function* FETCH_AGENT_COMMISSION({ payload }) {
  const { agentId, month, year, includeDetails = false } = payload

  yield put({ type: actions.SET_STATE, payload: { commissionLoading: true } })

  try {
    const response = yield call(
      Services.getMonthlyAgentCommission,
      agentId,
      month,
      year,
      includeDetails,
    )

    if (!response.error) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          commissionLoading: false,
          agentCommission: response.data || {},
        },
      })
    } else {
      yield put({ type: actions.SET_STATE, payload: { commissionLoading: false } })
      showError(response.message)
    }
  } catch (err) {
    yield put({ type: actions.SET_STATE, payload: { commissionLoading: false } })
    showError(err.message)
  }
}

export function* FETCH_AGENT_YEARLY_COMMISSION({ payload }) {
  const { agentId, year } = payload
  yield put({ type: actions.SET_STATE, payload: { commissionLoading: true } })

  try {
    const response = yield call(Services.getYearlyAgentCommission, agentId, year)
    if (!response.error) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          commissionLoading: false,
          yearlyAgentCommission: response,
        },
      })
    } else {
      yield put({ type: actions.SET_STATE, payload: { commissionLoading: false } })
      showError(response.message)
    }
  } catch (err) {
    yield put({ type: actions.SET_STATE, payload: { commissionLoading: false } })
    showError(err.message)
  }
}

export function* FETCH_MERCHANT_FEE({ payload }) {
  const { businessId } = payload

  yield put({
    type: actions.SET_STATE,
    payload: { merchantFeeLoading: true },
  })

  try {
    const response = yield call(Services.getRateDetails, businessId)

    if (!response.error) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          merchantFeeLoading: false,
          merchantFee: response.data?.processingFee || [],
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: { merchantFeeLoading: false },
      })
      showError(response.message)
    }
  } catch (err) {
    yield put({
      type: actions.SET_STATE,
      payload: { merchantFeeLoading: false },
    })
    showError(err.message)
  }
}

export function* FETCH_SUB_AGENTS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { isSubAgentsLoading: true },
  })
  const response = yield call(Services.getSubAgents, payload.agentId)
  if (response && response.data) {
    yield put({
      type: actions.SET_STATE,
      payload: { subAgents: response.data.agents },
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: { isSubAgentsLoading: false },
  })
}

export function* CREATE_SUB_AGENT({ payload }) {
  const { agentId, data, callback } = payload
  const response = yield call(Services.createSubAgent, agentId, data)
  if (response) {
    if (callback) callback(response)
    yield put({
      type: actions.FETCH_SUB_AGENTS,
      payload: { agentId },
    })
  }
}

export function* ASSIGN_MERCHANT_TO_SUB_AGENT({ payload }) {
  const { agentId, subAgentId, data, callback } = payload
  const response = yield call(Services.assignMerchantToSubAgent, agentId, subAgentId, data)
  if (response) {
    if (callback) callback(response)
    yield put({
      type: actions.FETCH_SUB_AGENTS,
      payload: { agentId },
    })
  }
}

export function* FETCH_PAYOUT_HISTORY({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { isPayoutHistoryLoading: true },
  })
  const response = yield call(Services.getAgentPayouts, payload.agentId)
  if (response && response.data) {
    yield put({
      type: actions.SET_STATE,
      payload: { payoutHistory: response.data.payouts },
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: { isPayoutHistoryLoading: false },
  })
}

function showError(msg) {
  notification.error({
    message: 'Try again',
    description: msg,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_SALES_AGENT_BY_ID, FETCH_SALES_AGENT_BY_ID),
    takeEvery(actions.FETCH_AGENT_COMMISSION, FETCH_AGENT_COMMISSION),
    takeEvery(actions.FETCH_AGENT_YEARLY_COMMISSION, FETCH_AGENT_YEARLY_COMMISSION),
    takeEvery(actions.FETCH_MERCHANT_FEE, FETCH_MERCHANT_FEE),
    takeEvery(actions.FETCH_SUB_AGENTS, FETCH_SUB_AGENTS),
    takeEvery(actions.CREATE_SUB_AGENT, CREATE_SUB_AGENT),
    takeEvery(actions.ASSIGN_MERCHANT_TO_SUB_AGENT, ASSIGN_MERCHANT_TO_SUB_AGENT),
    takeEvery(actions.FETCH_PAYOUT_HISTORY, FETCH_PAYOUT_HISTORY),
  ])
}
